import { LoadingOutlined } from '@ant-design/icons'
import { Input, message, Modal, Select, Spin } from 'antd'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import DynamicTable from '../../../Components/TableComponents/DynamicTable'
import { ContractorTo, get_employee_AssignTo_listing_not_Terminated } from '../../../Services/employee'
import { getTicketCategory, updateTicketCategory, updateWorkOrderById } from '../../../Services/LocomotiveServices'

const WOAssignedToModal = ({ open, close, modalData, setReloadState: reload }) => {

    const [loader, setLoader] = useState(false)
    const [selectedOption, setSelectedOption] = useState(undefined)
    const [inputOption, setInputOption] = useState(undefined)
    const [listings, setListings] = useState({
        employee: [],
        contractor: []
    })

    const contractormap = (data) => {
        if (data) {
            let { firstName, lastName, Company } = data;
            let output = '';

            if (Company)
                output = Company;
            if (Company && firstName && lastName)
                output = output + "-"
            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName[0]}.`

            return output;
        }
        return ''

    };

    const getEmployeeData = async () => {
        setLoader(true)
        let result = await get_employee_AssignTo_listing_not_Terminated()
        if (result?.httpStatus === 200) {
            const list = result?.data?.rows?.map((item, index) => {
                return {
                    label: `${item?.firstName} ${item?.lastName}`,
                    value: item?.id
                }
            })
            setListings(prev => { return { ...prev, employee: list } })
            setLoader(false)
        }
        setLoader(false)
    }

    const getContractorData = async () => {
        setLoader(true)
        let result = await ContractorTo();
        if (result?.httpStatus === 200) {
            const list = result?.data?.map((item, index) => {
                return {
                    label: `${contractormap(item)}`,
                    value: item?.id
                };

            });
            setListings(prev => { return { ...prev, contractor: list } });
            setLoader(false)
        }
        setLoader(false)

    };

    useEffect(() => {
        if (open) {
            getEmployeeData();
            getContractorData();
            if (modalData?.values?.AssignedToId) {
                setSelectedOption('employee');
                setInputOption(modalData?.values?.AssignedToId)
            } else if (modalData?.values?.AssignedToContractorId) {
                setSelectedOption('contractor');
                setInputOption(modalData?.values?.AssignedToContractorId)

            }
        }
    }, [open])

    const onClickSave = async () => {
        let res = await updateWorkOrderById(modalData?.values?.id, { AssignedToId: inputOption })
        if (res?.httpStatus === 200) {
            message.success('Assigned To Updated Successfully!')
            close()
            reload(prev => prev = !prev)
        }
    }


    return (
        <Modal
            open={open}
            onCancel={() => {
                close()
            }}
            footer={null}
            title="Update WO Assigned To"
        >
            <Spin
                spinning={loader || false}
                indicator={<LoadingOutlined
                    style={{
                        fontSize: 24,
                    }}
                    spin
                />}>
                <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <span style={{ fontSize: "13px" }}>WO Assigned To</span>
                                <span style={{ fontSize: "10px", color: "gray" }}>{["contractor", "employee"]?.includes(selectedOption) ? selectedOption?.charAt(0).toUpperCase() + selectedOption?.slice(1).toLowerCase() : ""}</span>
                            </div>
                            {
                                ['Back', undefined, null]?.includes(selectedOption)
                                    ? <Select
                                        value={undefined}
                                        onChange={e => setSelectedOption(e)}
                                        placeholder='Select Option'
                                    >
                                        <Select.Option value="employee">Employee</Select.Option>
                                        <Select.Option value="contractor">Contractor</Select.Option>
                                    </Select>
                                    : selectedOption === "contractor"
                                        ? <Select
                                            showSearch
                                            value={inputOption}
                                            optionFilterProp="children"
                                            onChange={e => {
                                                if (e === "Back") {
                                                    setSelectedOption(e)
                                                    setInputOption(null)
                                                } else setInputOption(e)
                                            }}
                                            filterOption={(inputValue, option) => option.children ? option.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                                            required={true}
                                        >
                                            <Select.Option style={{ textAlign: 'center', fontWeight: 'bold' }} value="Back">Back</Select.Option>
                                            {
                                                listings?.contractor?.map((item) => (
                                                    <Select.Option value={item?.value}>{item?.label}</Select.Option>
                                                ))
                                            }
                                        </Select>
                                        : selectedOption === "employee"
                                            ? <Select
                                                showSearch
                                                value={inputOption}
                                                optionFilterProp="children"
                                                onChange={e => {
                                                    if (e === "Back") {
                                                        setSelectedOption(e)
                                                        setInputOption(null)
                                                    } else setInputOption(e)
                                                }}
                                                filterOption={(inputValue, option) => option.children ? option.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                                                required={true}
                                            >
                                                <Select.Option style={{ textAlign: 'center', fontWeight: 'bold' }} value="Back">Back</Select.Option>
                                                {
                                                    listings?.employee?.map((item) => (
                                                        <Select.Option value={item?.value}>{item?.label}</Select.Option>
                                                    ))
                                                }
                                            </Select>
                                            : <></>
                            }
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <button
                            style={{ background: "#2863AD", color: "white", padding: "10px 20px", border: "none", borderRadius: "10px", cursor: "pointer", opacity: inputOption ? "1" : "0.4" }}
                            onClick={onClickSave}
                            disabled={inputOption ? false : true}
                        >
                            Update
                        </button>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

export default WOAssignedToModal